// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2zpJi","cell":"ColumnAccessor_cell__2huWT","firstCellAccent":"ColumnAccessor_firstCellAccent__36WWK"};